import type { QuoterMarketConfig } from '../contract/market';
import { INT } from './int';
import { MX } from './mx';
import { BR } from './br';

export type DeclaredMarket = 'INT' | 'MX' | 'BR';

export const MARKETS: Record<DeclaredMarket, QuoterMarketConfig> = { INT, MX, BR };

export { INT, MX, BR };
